export default __webpack_public_path__ + "8ddfc95.png";